var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgIndicatorLock = function SvgIndicatorLock(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 13 13"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#indicator-lock_svg__a)"
  }, /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#indicator-lock_svg__b)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement(Path, {
    stroke: "#FF9",
    d: "M3.762 5.491V4.098c0-.739.301-1.447.837-1.97a2.9 2.9 0 0 1 2.02-.816c.758 0 1.485.294 2.02.816a2.75 2.75 0 0 1 .837 1.97v1.393"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#FF9",
    d: "M9.476 4.047H3.762c-.789 0-1.428.623-1.428 1.392v4.179c0 .77.64 1.393 1.428 1.393h5.714c.79 0 1.429-.624 1.429-1.393V5.439c0-.769-.64-1.392-1.429-1.392"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    d: "M6.5 6.252v2.786Z"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#330E07",
    strokeWidth: 1.286,
    d: "M6.5 6.252v2.786"
  })))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "indicator-lock_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h13v13H0z"
  })), /*#__PURE__*/React.createElement(ClipPath, {
    id: "indicator-lock_svg__b"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M1.5.5h10v13h-10z"
  })))));
};
export default SvgIndicatorLock;